import { render } from "./EngagementRGPD.vue?vue&type=template&id=47cadbc2"
import script from "./EngagementRGPD.vue?vue&type=script&lang=js"
export * from "./EngagementRGPD.vue?vue&type=script&lang=js"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__